/**
 * 抽出に利用したSQL（BigQuery）
SELECT medico_hospitals.name, key, hospital_user_keys.hospital_user_id FROM `ubie-production-svc.db_diagnosis_inquiry.hospital_user_keys` hospital_user_keys
LEFT JOIN `ubie-production-svc.db_diagnosis_inquiry.hospital_users` hospital_users ON hospital_user_keys.hospital_user_id = hospital_users.id
LEFT JOIN `ubie-production-svc.db_diagnosis_public.medico_hospitals` medico_hospitals ON hospital_user_keys.hospital_user_id = medico_hospitals.hospital_user_id
WHERE medico_hospitals.id is not null AND hospital_user_keys.key_type = 'PreHospital'
ORDER BY medico_hospitals.id, hospital_user_id
 */

export const medicalInstitutionIdKeyMap: Array<{
  name: string;
  key: string;
  hospital_user_id: string;
}> = [
  {
    name: '宇都宮セントラルクリニック',
    key: 'M1VBUhDGD8NqGroI',
    hospital_user_id: '21',
  },
  {
    name: '東京リウマチクリニック',
    key: '4idcrHwPgzm2yOjf',
    hospital_user_id: '184',
  },
  {
    name: '同友会 春日クリニック',
    key: 'HqZjIHYBApMqsJgn',
    hospital_user_id: '72',
  },
  {
    name: 'コンフォガーデンクリニック',
    key: 'kxZQX87C05Mpfl3w',
    hospital_user_id: '185',
  },
  {
    name: 'おなか会 おなかクリニック',
    key: 'wJEdsuDak8G3UqBC',
    hospital_user_id: '186',
  },
  {
    name: '目黒みらい内科クリニック',
    key: 'IJdUSWZ7YEp766Bn',
    hospital_user_id: '128',
  },
  {
    name: '医療法人良秀会 高石藤井病院',
    key: '1StHSM6PeezcRoT5',
    hospital_user_id: '145',
  },
  {
    name: '医療法人良秀会 高石藤井心臓血管病院',
    key: 'irfoSHqgFfnuzhAr',
    hospital_user_id: '146',
  },
  {
    name: '医療法人社団鴻愛会こうのす共生病院',
    key: 'tjZ3i6iZViFvrFSh',
    hospital_user_id: '104',
  },
  {
    name: '東長崎駅前内科クリニック',
    key: '8EwdeEM2apumYLrI',
    hospital_user_id: '65',
  },
  {
    name: '高橋まことクリニック',
    key: 'PjUpqKEBkjGqNSmY',
    hospital_user_id: '44',
  },
  {
    name: 'さむら脳神経クリニック',
    key: 'wGU0P52VSDIcMQWK',
    hospital_user_id: '197',
  },
  {
    name: '松波総合病院　まつなみ健康増進クリニック',
    key: 'GvJe3DsDs6vwj1ql',
    hospital_user_id: '240',
  },
  {
    name: '福岡和白病院',
    key: 'qzysagqEJqPdrCq0',
    hospital_user_id: '201',
  },
  {
    name: '田主丸中央病院',
    key: 'K5GvVTAuWmod15eF',
    hospital_user_id: '235',
  },
  {
    name: 'いのうえ内科脳神経クリニック',
    key: 'FvyRAKHusXJFJ9M1',
    hospital_user_id: '280',
  },
  {
    name: '千鳥橋病院・千代診療所',
    key: 'm7MjrCzdFnkK1dhB',
    hospital_user_id: '260',
  },
  {
    name: '目々澤醫院',
    key: 'lEbZrZtK5Q1kjBPZ',
    hospital_user_id: '41',
  },
  {
    name: '戸畑共立病院',
    key: 'GCrlbSTkDsN9DGjZ',
    hospital_user_id: '212',
  },
  {
    name: '医療法人良秀会　藤井病院',
    key: 'ulVezuVNvyE4Uyi6',
    hospital_user_id: '147',
  },
  {
    name: 'オプティム病院',
    key: 'M402X0kRMSRGd8bR',
    hospital_user_id: '298',
  },
  {
    name: 'ふるかわメディカルクリニック',
    key: 'k0wAzBQC5f763Xyw',
    hospital_user_id: '47',
  },
  {
    name: '祐愛会 織田病院',
    key: '8q1xqskbs3aUadaL',
    hospital_user_id: '269',
  },
  {
    name: '恵寿総合病院',
    key: '8WS0zgfNKDrCkzYA',
    hospital_user_id: '141',
  },
  {
    name: '医療法人社団　宍戸医院',
    key: 'VnJHFhDOgLHfLPOx',
    hospital_user_id: '258',
  },
  {
    name: 'あゆみクリニック',
    key: 'TThFRT9T8Y1bpnAt',
    hospital_user_id: '67',
  },
  {
    name: '原土井病院',
    key: '6euFA5ae8FBqENGB',
    hospital_user_id: '173',
  },
  {
    name: '湘南内科皮フ科クリニック町田院',
    key: 'PYoX1AVde0o9D7rU',
    hospital_user_id: '157',
  },
  {
    name: '湘南内科クリニック六本木院',
    key: 'nrVMU9R7EFUqr9rX',
    hospital_user_id: '301',
  },
  {
    name: '博愛会 菅間記念病院',
    key: 'KQlnlTQJu2zYA0Nf',
    hospital_user_id: '164',
  },
  {
    name: '岡山旭東病院',
    key: '6HuKOJH5KF1ROYSQ',
    hospital_user_id: '226',
  },
  {
    name: '黒田内科診療所',
    key: 's4454xc4cg4P7LAo',
    hospital_user_id: '314',
  },
  {
    name: '日本海総合病院',
    key: 'D7Wa1sQAzqWnzYCJ',
    hospital_user_id: '69',
  },
  {
    name: 'かわもと心臓内科クリニック',
    key: 'sQJ6fNyq71rbNGSb',
    hospital_user_id: '317',
  },
  {
    name: 'ヨコクラ病院',
    key: 'cqavufYFrhTp6EAM',
    hospital_user_id: '154',
  },
  {
    name: '医療法人木村ファミリークリニック',
    key: 'HX2Phvx9WNiB6yIi',
    hospital_user_id: '323',
  },
  {
    name: '伊勢丘内科クリニック',
    key: 'XHGQYufdnvccQFo6',
    hospital_user_id: '322',
  },
  {
    name: '新武雄病院',
    key: 'XWpKPC232guwxXh8',
    hospital_user_id: '278',
  },
  {
    name: '海老名総合病院',
    key: 'e5K8ieYUkpSk0AU2',
    hospital_user_id: '252',
  },
  {
    name: '中部徳洲会病院',
    key: 'xFd1GVnF3x9gKkrO',
    hospital_user_id: '299',
  },
  {
    name: 'エーザイクリニック',
    key: '1t9N7ZGM6zbSDvtt',
    hospital_user_id: '337',
  },
  {
    name: '西宮渡辺病院',
    key: '8iaS9v65PsoMgtf9',
    hospital_user_id: '255',
  },
  {
    name: '公益財団法人大原記念倉敷中央医療機構　倉敷中央病院',
    key: 'MidWp0gewXUlS3FT',
    hospital_user_id: '205',
  },
  {
    name: '医療法人潤和会 札幌ひばりが丘病院',
    key: 'BojDLvQ2n9dqPvti',
    hospital_user_id: '343',
  },
  {
    name: '藤枝市立総合病院',
    key: 'wbaO6nR6sVqwDbQi',
    hospital_user_id: '288',
  },
  {
    name: '医療法人財団 康生会 武田病院',
    key: 'lP9IABOyZVAqnLf1',
    hospital_user_id: '224',
  },
  {
    name: '医療法人社団けいせい会　東京北部病院',
    key: 'ym99GLKWhN00yySF',
    hospital_user_id: '350',
  },
  {
    name: 'あおもりベイクリニック',
    key: 'l2ibtnNkXyD7FBBH',
    hospital_user_id: '351',
  },
  {
    name: '医療法人社団おおぞら会　つばさクリニック',
    key: 'H328nUSbzCV7yDbc',
    hospital_user_id: '353',
  },
  {
    name: '岐阜市民病院',
    key: 'XCfMzdVlZ7x6d7Gl',
    hospital_user_id: '359',
  },
  {
    name: '光生病院',
    key: 'uWhgU2xSyaUKdiov',
    hospital_user_id: '243',
  },
  {
    name: 'かりまた内科医院',
    key: 'VMasrHcMcx17VyOO',
    hospital_user_id: '365',
  },
  {
    name: '前原総合医療病院',
    key: 'AwfPQff83Ppm1FJR',
    hospital_user_id: '366',
  },
  {
    name: '医療法人恵喜会　森クリニック',
    key: '4zorCDzffQ6EL88w',
    hospital_user_id: '367',
  },
  {
    name: '医療法人社団北水会 北水会記念病院',
    key: '2APgUnisXxPVdpOA',
    hospital_user_id: '214',
  },
  {
    name: '広域紋別病院',
    key: 'QuqW3lGl1Nkz6KVQ',
    hospital_user_id: '291',
  },
  {
    name: 'サトーヘルスケア株式会社',
    key: 'nEn4WZd2kSjupChY',
    hospital_user_id: '374',
  },
  {
    name: 'わたなべクリニック',
    key: 'TFpp7SyAjhfOFNDU',
    hospital_user_id: '378',
  },
  {
    name: '長野中央病院',
    key: 'LOtvjducvECluThG',
    hospital_user_id: '126',
  },
  {
    name: '海老名メディカルプラザ',
    key: 'e5K8ieYUkpSk0AU2',
    hospital_user_id: '252',
  },
  {
    name: '山口医院',
    key: 'GH2EcTTPDqefLhhM',
    hospital_user_id: '393',
  },
  {
    name: '興生総合病院',
    key: 'cUWcuqTGPxcpE46v',
    hospital_user_id: '389',
  },
  {
    name: '社会医療法人仁愛会　浦添総合病院',
    key: 'vaLfHKh9sPGbMUxV',
    hospital_user_id: '192',
  },
  {
    name: '医療法人社団博愛会',
    key: '3ttOBJeq8h19Ef75',
    hospital_user_id: '275',
  },
  {
    name: '医療法人社団鴻愛会こうのす共生病院',
    key: 'tjZ3i6iZViFvrFSh',
    hospital_user_id: '104',
  },
  {
    name: '河口外科',
    key: 'xcnoqDJNeKK1eLQa',
    hospital_user_id: '368',
  },
  {
    name: '高須病院',
    key: '0y43AwIlRU9Ggwwe',
    hospital_user_id: '406',
  },
  {
    name: 'おなか・内科 東白壁クリニック',
    key: '0qZoQmidUQNnHKro',
    hospital_user_id: '420',
  },
  {
    name: '医療法人　植谷医院',
    key: 'FADhUPNLLod1LQ44',
    hospital_user_id: '417',
  },
  {
    name: '武蔵国分寺公園クリニック',
    key: 'SOb0PdSuAqfRkoIp',
    hospital_user_id: '144',
  },
  {
    name: 'いそざきファミリークリニック',
    key: 'JYC9wKEja3CuLWo4',
    hospital_user_id: '430',
  },
  {
    name: 'つちうら東口クリニック',
    key: '3irpPlMOlYz4g0Qo',
    hospital_user_id: '431',
  },
  {
    name: '竜王みついクリニック',
    key: 'HYkKWKB3z28VX9NV',
    hospital_user_id: '439',
  },
  {
    name: '新得クリニック',
    key: 'L4qR6ZnShF5E2pXk',
    hospital_user_id: '363',
  },
  {
    name: '井戸田整形外科名駅スポーツクリニック',
    key: 'QnaPLT7ziNNDLLXr',
    hospital_user_id: '447',
  },
  {
    name: '本郷会吉田医院',
    key: 'TvsvHn3lxMcvqSoQ',
    hospital_user_id: '451',
  },
  {
    name: 'しげた総合診療クリニック',
    key: '5ZeqVqFDXXaddXVF',
    hospital_user_id: '454',
  },
  {
    name: '医療法人永元会はしもとじんクリニック',
    key: 'hSy8prswfTV8ySdO',
    hospital_user_id: '455',
  },
  {
    name: '白岩内科医院',
    key: 'BbJ2RQ7huPO6Fca2',
    hospital_user_id: '256',
  },
  {
    name: 'ちえ内科クリニック',
    key: 'XCOPkvxEnAn908VF',
    hospital_user_id: '475',
  },
  {
    name: '安どうクリニック',
    key: 'NokED0CjrpJ8avaR',
    hospital_user_id: '477',
  },
  {
    name: 'あげお東口内科',
    key: 'T637v9XdxBl8pf47',
    hospital_user_id: '482',
  },
  {
    name: '和田医院',
    key: 'Zw4iXVomeuSxv70U',
    hospital_user_id: '487',
  },
  {
    name: 'あいち健康クリニック',
    key: 'eBT6FzvbVtQ1XVqT',
    hospital_user_id: '382',
  },
  {
    name: '明日香村国民健康保険診療所',
    key: 'NVSDfD35n7LjKxsW',
    hospital_user_id: '387',
  },
  {
    name: 'わかばクリニック',
    key: 'Rao2o3SY29zIwuOK',
    hospital_user_id: '398',
  },
  {
    name: '長沼内科消化器科',
    key: '9b3hSPk3JHAjdNZz',
    hospital_user_id: '341',
  },
  {
    name: '下山記念クリニック',
    key: 'HrmoSzCpIEqMWW4b',
    hospital_user_id: '347',
  },
  {
    name: '筑波総合クリニック',
    key: 'ZMGp4XyRq1DaCvlc',
    hospital_user_id: '397',
  },
  {
    name: '丸亀メンタルクリニックソフィア',
    key: '9WTdtjrGhss9mBOE',
    hospital_user_id: '88',
  },
  {
    name: '医療法人社団勇往会 竹下医院',
    key: 'nmy9RZd87jV12O3p',
    hospital_user_id: '371',
  },
  {
    name: '丸太町リハビリテーションクリニック',
    key: 'hUI2US76oO2pxlkL',
    hospital_user_id: '369',
  },
  {
    name: '黒田クリニック',
    key: '5mL39U3U6ES3cNP0',
    hospital_user_id: '386',
  },
  {
    name: '川越救急クリニック',
    key: 'UyXgKoHqWKC3eP9i',
    hospital_user_id: '55',
  },
  {
    name: '今帰仁診療所',
    key: 'EfMMY9ebGa97DvGB',
    hospital_user_id: '488',
  },
  {
    name: '医療法人社団　弓削メディカルクリニック',
    key: 'udiRI61MGtUhG1WB',
    hospital_user_id: '491',
  },
  {
    name: '医療法人社団　三友会　高円寺整形外科',
    key: 'uO5MhYT0qt5ubZeJ',
    hospital_user_id: '493',
  },
  {
    name: '竜王町国民健康保険診療所（医科）',
    key: 'sNqQ9k6GdoVcGfCl',
    hospital_user_id: '490',
  },
  {
    name: 'たつみクリニック',
    key: 'QWm98Dw0irlIX7ZC',
    hospital_user_id: '497',
  },
  {
    name: '木下整形外科クリニック',
    key: 'tDLd3ZbyXzmHVX7N',
    hospital_user_id: '499',
  },
  {
    name: '医療法人春陽会　サクラクリニック',
    key: 'qbs3hZ4iLoa70oDA',
    hospital_user_id: '498',
  },
  {
    name: '医療法人　丸屋クリニック',
    key: 'XcfUngiVTYeIc8dK',
    hospital_user_id: '500',
  },
  {
    name: '医療法人社団健徳会 吉田医院',
    key: 't16wzC6eQ3h3NJhm',
    hospital_user_id: '505',
  },
  {
    name: '榊田泌尿器科外科医院',
    key: '8Cl9LMLhniBfAV31',
    hospital_user_id: '510',
  },
  {
    name: '保坂メディカルクリニック',
    key: '0V1wa1Tye7Pv3QmK',
    hospital_user_id: '508',
  },
  {
    name: '安田内科小児科医院',
    key: 'ok8JIsaHgaKzYsqj',
    hospital_user_id: '515',
  },
  {
    name: 'なかやま内科診療所',
    key: 'A6HcXG8iYKz2XIDd',
    hospital_user_id: '517',
  },
  {
    name: '小澤内科胃腸科',
    key: 'FCWuVkLfcQWZ81lA',
    hospital_user_id: '516',
  },
  {
    name: 'ゼロマチクリニック天神',
    key: 'xGqk3fbB2xcKpO7g',
    hospital_user_id: '521',
  },
  {
    name: 'じんのクリニック',
    key: '9lV4et4j7fJ6CJlE',
    hospital_user_id: '524',
  },
  {
    name: 'すこやかクリニック',
    key: 'O5jcbNM3CuXHMzGq',
    hospital_user_id: '523',
  },
  {
    name: '土屋医院',
    key: 'R0MWUXUt6VD0iTld',
    hospital_user_id: '528',
  },
  {
    name: '医療法人　橋本クリニック',
    key: 'Y6FS2yAfWm87hD3E',
    hospital_user_id: '527',
  },
  {
    name: 'みらいメディカルクリニック茗荷谷',
    key: 'kPoAIuGwHFOCLTxm',
    hospital_user_id: '529',
  },
  {
    name: 'SSK茶屋町クリニック',
    key: 'B8JDxYcc4GuDQihb',
    hospital_user_id: '526',
  },
  {
    name: '津軽保健生活協同組合　健生クリニック',
    key: 'keiuFRvj0cIE9IHN',
    hospital_user_id: '355',
  },
  {
    name: 'やの内科・胃腸クリニック',
    key: 'F6eucoZ0jkGCIxND',
    hospital_user_id: '539',
  },
  {
    name: '鈴木医院',
    key: 'i41k5W33ZF6NpH2M',
    hospital_user_id: '540',
  },
  {
    name: '乾医院',
    key: 'HvlPpQjWXBdAnPRe',
    hospital_user_id: '538',
  },
  {
    name: '西遠クリニック',
    key: 'w7Ct7wncEK1pEGz2',
    hospital_user_id: '545',
  },
  {
    name: '脳神経外科ふくおかクリニック',
    key: 'kJaYkBoKju31KhC7',
    hospital_user_id: '560',
  },
  {
    name: '医療法人正茂会小出医院',
    key: '7NpiOVaPOx8Q5JbM',
    hospital_user_id: '559',
  },
  {
    name: '岡原クリニック',
    key: 'ayOlssQHuyRLXjOb',
    hospital_user_id: '558',
  },
  {
    name: '山田メディカルクリニック',
    key: 'j3GSHBfYOBygGXIn',
    hospital_user_id: '572',
  },
  {
    name: '医療法人ふじわら医院',
    key: 'kJnGOPaFGJCfGU1t',
    hospital_user_id: '571',
  },
  {
    name: '西村クリニック',
    key: 'stCQvqbsFePs0PYD',
    hospital_user_id: '567',
  },
  {
    name: '玉井整形外科医院',
    key: 'aTzhTjOt87xexagn',
    hospital_user_id: '566',
  },
  {
    name: '千石はやし内科クリニック',
    key: 'W03a2eVD3I3kaMYu',
    hospital_user_id: '564',
  },
  {
    name: '岩渕胃腸科内科クリニック',
    key: 'lwc8qsaGWTv7Gdho',
    hospital_user_id: '587',
  },
  {
    name: '上竹医院',
    key: 'xOKCU7nalwOH90Eo',
    hospital_user_id: '586',
  },
  {
    name: '阿部医院',
    key: 'Oi1LAjSlj1BKnfa0',
    hospital_user_id: '591',
  },
  {
    name: '中村脳神経内科クリニック',
    key: 'hNSYAazWumLbArEG',
    hospital_user_id: '602',
  },
  {
    name: '医療法人社団彦星会　岩橋クリニック',
    key: 'jaVr8Dm6lgyPMHEL',
    hospital_user_id: '603',
  },
  {
    name: '一般社団法人　HonestLINK　オネストLクリニック',
    key: 'zxO6x9H07YSD3opF',
    hospital_user_id: '613',
  },
  {
    name: 'けやき心の発達診療所',
    key: 'NtyqsnQRVrojBnvs',
    hospital_user_id: '616',
  },
  {
    name: '元浅草いけだクリニック',
    key: 'UupakwyIpkkRLOei',
    hospital_user_id: '115',
  },
  {
    name: '医療法人社団亮敬会　板垣医院',
    key: 'zbBEqUfxpizRvc2k',
    hospital_user_id: '615',
  },
];
